import { render, staticRenderFns } from "./AccessPermissionsList.vue?vue&type=template&id=02485260&scoped=true&"
import script from "./AccessPermissionsList.vue?vue&type=script&lang=ts&"
export * from "./AccessPermissionsList.vue?vue&type=script&lang=ts&"
import style0 from "./AccessPermissionsList.vue?vue&type=style&index=0&id=02485260&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02485260",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VCol,VContainer,VDivider,VIcon,VList,VListItem,VListItemContent,VListItemTitle,VProgressLinear,VRow,VSnackbar,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02485260')) {
      api.createRecord('02485260', component.options)
    } else {
      api.reload('02485260', component.options)
    }
    module.hot.accept("./AccessPermissionsList.vue?vue&type=template&id=02485260&scoped=true&", function () {
      api.rerender('02485260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/access-permissions/components/AccessPermissionsList.vue"
export default component.exports